/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 割引マスタ更新情報
 */
export interface Szza031aRequestDiscntMasterUpdateInfDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode: string;
    /**
     * 商品コード：英数字
     */
    goodsCode: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode: string;
    /**
     * 割引指定区分１：数字
     */
    discntSiteiDiv1: string;
    /**
     * 割引指定区分２：数字
     */
    discntSiteiDiv2: string;
    /**
     * 割引指定区分３：数字
     */
    discntSiteiDiv3: string;
    /**
     * 割引指定区分４：数字
     */
    discntSiteiDiv4: string;
    /**
     * 割引指定区分５：数字
     */
    discntSiteiDiv5: string;
    /**
     * 割引範囲開始値：数字<br>　精度(3)
     */
    discntRangeStart: number;
    /**
     * 適用開始日付(変更前)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    applyStartDateBefore?: string | null;
    /**
     * 適用開始日付(変更後)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定
     */
    applyStartDate?: string | null;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate: string;
    /**
     * 更新通番号：数字<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    updateSrno?: string | null;
    /**
     * 割引正式名称：全角
     */
    discntAname: string;
    /**
     * 割引略称名称：全角
     */
    discntRyaku: string;
    /**
     * 割引範囲終了値：数字<br>　精度(3)
     */
    discntRangeEnd: number;
    /**
     * 割引タイプコード：数字<br>　画面項目ID＝\'C011553\'（\'1\'：割引単価（円）、\'2\'：割引率（％））
     */
    discntType: string;
    /**
     * 割引対象料金下限額：数字
     */
    discntTargetMin?: number | null;
    /**
     * 割引上限金額：数字
     */
    discntMaxValue?: number | null;
    /**
     * 割引パーセント：数字
     */
    discntRate?: number | null;
}

